import { AnalyticsAttributesProvider, Markdown } from "../../components";
import { UiQuoteModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import { Figure, LogoWrapper } from "./UiQuote.styles";

export type UiQuoteProps = {
    model: UiQuoteModel;
};

const UiQuote = ({ model }: UiQuoteProps) => {
    const { entryTitle, quote, attribution, logo } = model.content;

    return (
        <AnalyticsAttributesProvider
            value={{
                eventColumn: quote,
                eventContainer: model.type,
                labelEnglish: entryTitle
            }}
        >
            <Figure>
                <blockquote>{quote}</blockquote>
                <figcaption>
                    <Markdown>{attribution}</Markdown>
                    {logo && <LogoWrapper>{renderViewModel(logo)}</LogoWrapper>}
                </figcaption>
            </Figure>
        </AnalyticsAttributesProvider>
    );
};

export default UiQuote;
